module.exports = __webpack_public_path__ + "img/animasi.083710b3.png";